// extracted by mini-css-extract-plugin
export default {"addStaffBtn":"staff_addStaffBtn__uYQKT","addStaffCont":"staff_addStaffCont__qzkA7","exit":"staff_exit__FNX-p","checkaval":"staff_checkaval__bfNo3"};